import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { SignaturePadModule } from 'angular2-signaturepad';
import { EmployeeAgreementComponent } from './employee-agreement.component';
import { EmployeeAgreementRoutingModule } from './employee-agreement-routing.module';
import { DocumentComponent } from './document/document.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';

@NgModule({
  declarations: [EmployeeAgreementComponent,
    DocumentComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MyDatePickerModule,    
    SignaturePadModule,
    EmployeeAgreementRoutingModule,
    NgxUiLoaderModule,
    PDFExportModule
  ],
  exports:[EmployeeAgreementComponent],
 providers:[DatePipe,DocumentComponent],
})
export class EmployeeAgreementModule { }